import {
  Image,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import { EshopCategory, EshopHeader } from '../components';
import { FeatureSectionProps } from './components/FeatureSection/FeatureSection.type';
import FeatureSection from './components/FeatureSection';
import { FeatureBannerProps } from './components/FeatureBanner/FeatureBanner.type';
import FeatureBanner from './components/FeatureBanner';
import { Footer } from '../../../components/Footer';
import { FC, useCallback, useEffect, useState } from 'react';
import { NavigationService } from '../../../services/navigation';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { EShopLayout } from '../../../WebLayout';
import { IS_WEB } from '../../../constants/platform';
import { addBase64Prefix } from '../../../services/addBase64Prefix';
import { shopping_cart } from '../../../assets/base64';
import { STYLE_VARS } from '../../../constants/style-vars';
import { FONTS } from '../../../constants';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../services/redux';
import { Loading } from '../../../components';
import OptionsApi from '../../../services/api/options.api';

const EShopHomePage: FC = () => {
  const isDesktop = useIsDesktop();
  const [banner, setBanner] = useState<string>();
  const [isLoadingBanner, setIsLoadingBanner] = useState<boolean>(true);

  const { categories, isLoading, error } = useSelector(
    (state: RootState) => state.eShopCategoryReducer
  );

  const getBanner = useCallback(async () => {
    try {
      setIsLoadingBanner(true);
      const res = await OptionsApi.getOptions();
      setBanner(res.data.fields.eshop_banner?.url);
    } catch (error: any) {
      console.log(error);
    } finally {
      setIsLoadingBanner(false);
    }
  }, []);

  useEffect(() => {
    getBanner();
  }, [getBanner]);

  if (isDesktop()) {
    return (
      <EShopLayout
        title="E-shop"
        icon={
          IS_WEB
            ? addBase64Prefix(shopping_cart)
            : require('../../../assets/shopping-cart.png')
        }
      >
        {isLoading === true ? (
          <View>
            <Loading />
          </View>
        ) : (
          <View>
            <Image
              source={{
                uri: banner,
              }}
              style={{
                width: '100%',
                height: 500,
                resizeMode: 'contain',
                marginBottom: 40,
              }}
            />
            <View
              style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                flexWrap: 'nowrap',
                marginBottom: 30,
              }}
            >
              {isLoading === false &&
                categories.map((category, index) => (
                  <View>
                    <TouchableOpacity
                      style={{
                        flexDirection: 'column',
                        alignItems: 'center',
                      }}
                      onPress={() => {
                        NavigationService.push('EShopCategoryPage', {
                          name: category.slug,
                        });
                      }}
                    >
                      <View
                        style={{
                          width: 80,
                          height: 80,
                          borderRadius: 50,
                          borderWidth: 2,
                          borderColor: STYLE_VARS.primaryColor,
                          aspectRatio: 1,
                          flexDirection: 'row',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        {category.image && (
                          <Image
                            source={{ uri: category.image.src }}
                            style={{
                              height: 40,
                              width: 40,
                            }}
                          />
                        )}
                      </View>
                      <Text
                        style={{
                          textAlign: 'center',
                          marginTop: 25,
                          fontFamily: FONTS.AvenirMedium,
                          fontWeight: '500',
                          fontSize: 15,
                          textTransform: 'uppercase',
                          color: STYLE_VARS.fccDarkerGrey,
                          width: 130,
                        }}
                      >
                        {category.name}
                      </Text>
                    </TouchableOpacity>
                  </View>
                ))}
            </View>
            <View>
              {categories.map((category, index) => {
                if (['food', 'beverages'].includes(category.slug)) {
                  return (
                    <FeatureSection category={category} key={category.id} />
                  );
                }
              })}
            </View>
            <View
              style={{
                flexDirection: 'row',
                flexWrap: 'wrap',
              }}
            >
              {isLoading === false &&
                categories &&
                categories.map((category, index) => {
                  return (
                    <View
                      style={{
                        // width: index + 1 === categories.length ? '100%' : '50%',
                        // paddingBottom: 20,
                        // paddingStart: (index % 2 !== 0 && index + 1 !== categories.length)
                        //   ? 10
                        //   : 0,
                        // paddingEnd: (index % 2 === 0 && index + 1 !== categories.length)
                        //   ? 10
                        //   : 0,
                        width: '50%',
                        paddingBottom: 20,
                      }}
                    >
                      <FeatureBanner
                        key={index}
                        bannerPath={category.banner_image}
                        name={category.name}
                        onPress={() => {
                          NavigationService.push('EShopCategoryPage', {
                            name: category.slug,
                          });
                        }}
                        //isFullSizeDesktop={index + 1 === categories.length}
                      />
                    </View>
                  );
                })}
            </View>
          </View>
        )}
      </EShopLayout>
    );
  }

  return (
    <ScrollView>
      {isLoading === false ? (
        <View>
          <EshopHeader isHaveSearch={false} />
          <Image
            style={{ aspectRatio: '10/5' }}
            source={{
              uri: banner,
            }}
          />
          <EshopCategory />
          <View style={styles.bannerContainer}>
            {categories.map((category, index) => {
              return (
                <FeatureBanner
                  key={index}
                  bannerPath={category.banner_image}
                  name={category.name}
                  onPress={() => {
                    NavigationService.push('EShopCategoryPage', {
                      name: category.slug,
                    });
                  }}
                />
              );
            })}
          </View>
        </View>
      ) : (
        <View style={{ marginVertical: 20 }}>
          <Loading />
        </View>
      )}
      <Footer />
    </ScrollView>
  );
};

export default EShopHomePage;

export const styles = StyleSheet.create({
  bannerContainer: { paddingHorizontal: 20, gap: 20, paddingVertical: 60 },
  container: {
    paddingHorizontal: 20,
  },
});
